import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-button.tsx
var LazyButton = lazy(() => import("./button-DSGFFoq4.js").then((n) => n.n).then((module) => ({ default: module.Button })));
function Button({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "button" }),
		children: /* @__PURE__ */ jsx(LazyButton, { ...props })
	});
}
function ButtonContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "button" }),
		children: /* @__PURE__ */ jsx(LazyButton, { ...props })
	});
}
var useButtonContent = () => {
	return useMemo(() => ({ button: { component: ButtonContent } }), []);
};
//#endregion
export { Button, useButtonContent };
